
import React from 'react';
import { Button } from '@/components/ui/button';

interface ShareOptionProps {
  icon: React.ReactNode;
  label: string;
  handler: () => void;
  index: number;
}

const ShareOption: React.FC<ShareOptionProps> = ({ icon, label, handler, index }) => {
  return (
    <Button
      variant="outline"
      size="sm"
      className="flex items-center justify-center h-12 w-12 p-2 hover:bg-joerg-50"
      onClick={handler}
      tabIndex={0}
      role="menuitem"
      aria-label={`Auf ${label} teilen`}
    >
      <span className="text-joerg-700">{icon}</span>
      <span className="sr-only">{label}</span>
    </Button>
  );
};

export default ShareOption;
